import type { ReactElement } from "react";

import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { composeFieldChipLabel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/filterOptions";
import type { IRelativeDateRange } from "app/pages/sales-intelligence/types/range";

import type { DynamicRelativeDateRangeOptions } from "../../../types/filterOptions";

import { translateOption } from "./utils";

const RelativeDateRangeFilterResult = ({
    filter,
    value,
    isActionEnabled = true,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IRelativeDateRange, DynamicRelativeDateRangeOptions>): ReactElement | null => {
    if (!value?.range || !value?.rangeType) {
        return null;
    }

    const valueLabel = `${translateOption(value.rangeType)} ${translateOption(value.range, true)}`;

    return (
        <FiltersChip
            text={composeFieldChipLabel(filter.options.label, valueLabel)}
            hideActionButton={!isActionEnabled}
            onClose={onFilterUpdate}
        />
    );
};

export default RelativeDateRangeFilterResult;
